<header>
  <div>
    <p-menubar #menu [model]="items" *ngIf="isAuthenticated">
      <ng-template pTemplate="start">
        <a class="navbar-brand float-left" [routerLink]="['/']">
          <img [src]="getTopLogo()" style="width: 143px; height: 35px" />
        </a>
      </ng-template>
      <ng-template pTemplate="end">
        <span style="margin-right: 10px;" *ngIf="currentUser.IsAuthenticated">{{currentUser.FirstName}} {{currentUser.LastName}}</span>
        <a (click)="logout()" class="iconbutton" title="Logout"><i class="fa fa-sign-out fa-2x"></i></a>
      </ng-template>
    </p-menubar>
  </div>
</header>
